<!--京获客旗舰版头部导航-->
<template>
  <div :class="[[isHome ? 'header-class__home' : 'header-class'], 'container']">
    <div class="displayStart">
      <div class="logo" style="cursor: pointer">
        <img src="@/assets/homePage_jhk/logo.png" style="width: 108px; height: 33px" alt />
      </div>
      <div class="module displayStart">
        <search @itemClick="itemClick" />
        <nav class="nav" ref="mainHeader">
          <template v-for="(item, ind) in headItem">
            <div class="nav-item" :style="{ position: 'relative' }" :class="{ navActive: topActive == ind }"
              @click="topTab(ind, item)" v-if="item.tittle == '首页'" :key="ind">
              {{ item.tittle }}
            </div>
            <div class="nav-item" :style="{ position: 'relative' }" :class="{ navActive: topActive == ind }"
              @click="topTab(ind, item)" v-if="item.tittle == '互动'" :key="ind">
              {{ item.tittle }}
            </div>
          </template>
          <span @click="handleLink(val)" class="nav-item nav-pcImgUrl" v-for="val in popList" :key="val.id"
            style="width: 100px; position: relative">
            <img style="
                max-width: 100px;
                height: 30px;
                top: 31%;
                position: absolute;
              " :src="val.pcImgUrl" alt="" />
          </span>
        </nav>
      </div>
    </div>

    <div class="rightContent">
      <div
        v-if="access"
        class="white-bar"
        @click="handleShowWhiteBar"
      >
        <img
          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/white-bar-entrance.png"
          style="width: 90px; height: 34px;"
          alt=""
        />
      </div>
      <!-- 到期时间 -->
      <img class="daoQi" src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/jhkHome/expireIcon.png" alt="">
      <div class="timeStyle">
        到期时间：
        <span>{{ sellerPlatform.invalidateDate }}</span>
        <span class="renewStyle" @click="AppAuth">续费</span>
      </div>
      <!-- 帮助中心 -->
      <el-popover placement="bottom" width="236" trigger="hover">
        <div class="displayStart helpBlock" slot="reference">
          <div class="tips">
            <img src="../assets/homePage/help2.png" style="width: 14px; height: 14px; margin-right: 8px" />
            帮助中心
          </div>
        </div>
        <div></div>
        <!-- 帮助中心 -->
        <div class="customerService">
          <div class="help">
            <a href="https://www.yuque.com/yunduanxincrm/flgan6/kvqpvswxw3ob1b9c?# 《一、京获客介绍》"
              style="text-decoration: none; color: #333333" target="_blank">
              <div class="helpNoHover">
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/help.svg" alt style="width: 14px; height: 14px" />&nbsp;帮助文档
              </div>
              <div class="helpHover">
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/helpHover.svg" alt style="width: 14px; height: 14px" />&nbsp;帮助文档
              </div>
            </a>
          </div>

          <div class="toService displayStart">
            <div class="title">客服热线：</div>
            <div class="phone">
              020-28970151
              <span class="phoneBtn">
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/copy.svg" alt @click="copyBtn('020-28970151')"
                  style="width: 16px; height: 16px; cursor: pointer" class="copyBtn" />
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/copyHover.svg" alt @click="copyBtn('020-28970151')"
                  style="width: 16px; height: 16px; cursor: pointer" class="copyBtnHover" /></span>
            </div>
          </div>
          <div class="toService displayStart">
            <div class="title">周末客服：</div>
            <div class="phone">
              18925068928
              <span class="phoneBtn">
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/copy.svg" alt @click="copyBtn('18925068928')"
                  style="width: 16px; height: 16px; cursor: pointer" class="copyBtn" />
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/copyHover.svg" alt @click="copyBtn('18925068928')"
                  style="width: 16px; height: 16px; cursor: pointer" class="copyBtnHover" />
              </span>
            </div>
          </div>
          <div class="wechatService">
            <div class="QRcode">
              <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/code-four.png" alt style="width: 100%" />
              <span calss="title">云起小助手A</span>
            </div>
            <div class="QRcode">
              <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/code-five.png" alt style="width: 100%" />
              <span calss="title">云起小助手B</span>
            </div>
          </div>
        </div>
      </el-popover>

      <!-- 员工信息 -->
      <div>
        <el-popover placement="bottom" width="150" trigger="hover" style="padding: 0" class="platformFlag">
          <div slot="reference" class="displayStart">
            <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/newHome/topMember.svg" alt style="width: 26px" />
            <div class="shopTitle">
              <div class="outWidth fs12 colorfff">
                <div>{{ shopTitle }}</div>
              </div>
            </div>
            <!--  向下的箭头按钮 -->
            <img src="@/assets/homePage/down.png" style="width: 12px; height: 12px" />
          </div>
          <div>
            <div class="callkf1" @click="log_out" style="width: 100%;">
              退出登录
            </div>
          </div>
        </el-popover>
      </div>
    </div>
    <el-dialog title="公告内容" :close-on-click-modal="false" :append-to-body="true" :visible.sync="isPopVisiv"
      width="800px" :class="{ dialongTransition12: popItem.type == 0 }">
      <div style="display: flex; justify-content: center" v-if="popItem.type == 0">
        <div style="position: relative">
          <img @click="handleUrl" class="pointer" :src="popItem.pcPic" alt
            style="max-width: 100%; margin: 0 auto; margin-top: 38px" />
          <img class="pointer" style="position: absolute" @click="isPopVisiv = false" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/btn_关闭.png"
            alt="" width="29" height="29" />
        </div>
      </div>
      <template v-else>
        <div style="height: 500px; overflow-y: auto; padding-bottom: 20px" v-html="popItem.richText"></div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import {
  getSellerInfo,
  getShopInfo,
  getMenuList,
  getSeller,
  // homeController,
  getSellerPlatform,
  setDefault,
} from "@/api/sellerController";
import { getSellerInfo as getJhkSellerInfo } from "@/api/jhk/sellerController.js"
import { homeController } from "@/api/jhk/sellerController.js"
import { logout } from "@/api/jhk/login.js";
import aiDialog from "@/components/ai-message.vue";
import aiService from "@/components/ai/aiService.vue";
import encrypt from "@/components/common/encryptEye.vue";
import changePwd from "@/views/permissionManagement/components/changePwd/index.vue";
import search from "./common/search.vue";
import JdButton from "./new/jd-button.vue";
import {newAndOldShopIsPopUp,getMAToken,getOnceToken} from "@/api/whiteBar";
import {getShopList} from "@/api/public";
export default {
  name: "page-header",
  props: {
    paths: {
      type: Array,
      require: true,
    },
  },
  components: {
    aiDialog,
    changePwd,
    encrypt,
    search,
    aiService,
    JdButton,
  },
  watch: {
    paths(newVal, oldVal) {
      if (this.paths && this.paths.length > 0) {
        let ind = this.paths[0].index;
        this.topActive = ind;
        if (this.topActive == 5 && this.$route.query.venderId) {
          this.loginEvent();
        }
        //只需要刷新的时候调用一次
        this.bus.$emit("topActive", { index: ind, item: this.headItem[ind] });
        this.$nextTick(() => {
          this.activeNavStyle = this.getNavStyle(this.topActive);
        });
      }
    },
  },
  data() {
    return {
      shopList: [],
      appKey: "22AF00009B3D46B8DECBC457090B3560",
      componentId: "B8CABEC9CBBD5815C4C7BB89D7D45461",
      access: false,
      frontComponentUrl:"",
      reqId: "",
      pathsOne: "",
      //Note--剩余富信短信
      fuxinSms: "",
      isPopVisiv: false,
      popItem: {},
      popList: [],
      topActive: 0,
      switchList: [],
      softwareInfo: {
        versionName: "POP版",
      },
      activeNavStyle: { left: 0, width: 0 },
      screenWidth: document.body && document.body.clientWidth, // 屏幕尺寸
      venId: null, //商家编号
      pathList: [],
      permissionPath: JSON.parse(localStorage.getItem("permissionPath")) || [],
      sellerPlatform: {
        useCardSmsTotal: "",
        payCardSmsTotal: "",
        useSmsTotal: "",
        paySmsTotal: "",
        platformversionEndDate: "",
        platformAccountInfo: {
          mistinessMobile: "",
        },
      }, //平台版用户信息
      platformFlag: false, //是否是平台版
      loginUserInfo: {
        shopTitle: "",
      },
    };
  },
  computed: {
    newplatformFlag() {
      return this.$store.getters.loginUserInfo.platformFlag;
    },
    ...mapState({
      globalBG: "globalBG",
      switchListStore: "switchList",
    }),
    headItem() {
      return this.$store.state.route;
    },
    isHome() {
      return this.$route.fullPath == "/home";
    },
    shopTitle() {
      return this.sellerPlatform ? this.sellerPlatform.shopTitle : '';
    },
  },
  mounted() {
    this.getFirstWhiteBarPop()
    var flag = sessionStorage.getItem("flag");
    this.bus.$on("topHeader", (obj) => {
      this.topTab(obj.index, obj.item);
    });
    console.log("location.pathname:", this.$route.path);
    if (
      location.pathname !== "/login" &&
      location.pathname !== "/" &&
      location.pathname !== "/platform/login" &&
      location.pathname !== "/platform/redirection" &&
      location.pathname !== "/platformLogin" &&
      location.pathname !== "/platform/platformLogin"
    ) {
      this.getBindList();
      // 获取菜单
      this.getMenuData();
      // 顶部栏图
      this.popups();
    }
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body && document.body.clientWidth;
        that.screenWidth = window.screenWidth + 17; // 17 估计是滚动条的距离
        this.$nextTick(() => {
          this.activeNavStyle = this.getNavStyle(this.topActive);
        });
      })();
    };
    // 获取京获客旗舰版用户数据
    this.getJhkSellerInfo();
  },

  methods: {
    ...mapMutations({
      editUserInfo: "LOGINUSERINFO",
      editPointUserInfo: "POINTUSERINFO",
      getSwitchList: "getSwitchList",
      saveShopInfo: "SHOPINFO",
      saveJhkPlatformSeller: "ISJHKPLATFORMSELLER",
    }),
    // 获取下单店铺接口
    getShopAllList() {
      const list = [
        {
          shopTitle: this.loginUserInfo.shopTitle,
          venderId: this.loginUserInfo.venderId,
          venderType: this.loginUserInfo.venderType,
          defaultFlag: true,
        }
      ];
      getShopList()
        .then((res) => {
          if (res.code == 1) {
            const resData = res.data.filter((item) => item);
            if (resData && resData.length) {
              // 灰度判断
              if(this.loginUserInfo.isGray) {
                this.shopList = list;
              } else {
                this.shopList = resData;
              }
            } else {
              this.shopList = list;
            }
            this.$store.commit("setShopList", this.shopList)
          } else {
            this.shopList = list;
            this.$store.commit("setShopList", this.shopList)
          }
        })
        .catch(() => {
          this.shopList = list
          this.setShopList(this.shopList)
        });
    },
    handleShowWhiteBar() {
      this.getWhiteBarPop()
    },
    // 调用白条弹窗
    getJdMicroAppOpen() {
      if(!window.jdMicroAppOpenInstance) {
        window.jdMicroAppOpenInstance = window.jdMicroAppOpen.create();
      }
      jdMicroAppOpenInstance.clear()
      // 打开组件
      jdMicroAppOpenInstance.open({
        appKey: this.appKey,
        target: "#whiteBar",
        componentId: this.componentId,
        getOnceToken: async() => {
          const res = await getMAToken({componentId: this.componentId})
          const res1 = await getOnceToken({maTokee: res.data.token})
          return res1.data.token
        },
        customParams: {
          sourceType: 'ISVYDX',
          reqId: this.reqId
        }
      });
    },
    getWhiteBarPop() {
      newAndOldShopIsPopUp().then((res)=>{
        if(res.code==1) {
          this.access = res.data.access
          this.reqId = res.data.reqId
          this.frontComponentUrl = res.data.frontComponentUrl
          if(this.access) {
            this.getJdMicroAppOpen()
          }
        }
      })
    },
    getFirstWhiteBarPop() {
      newAndOldShopIsPopUp().then((res)=>{
        if(res.code==1) {
          this.access = res.data.access
        }
      })
    },
    handleUrl() {
      if (this.popItem.pcUrl) {
        window.open(this.popItem.pcUrl, "_blank");
      }
    },
    handleLink(item) {
      if (item.pathType == 1) {
        window.open(item.pcPathUrl, "_blank");
      } else if (item.pathType == 2) {
        if (item.isNoGoingShow == 1 && item.popup.activityStatus == 2) {
          this.popItem = item.popup;
          this.isPopVisiv = true;
        }
        if (item.isNoGoingShow == 0) {
          this.popItem = item.popup;
          this.isPopVisiv = true;
        }
      }
    },
    popups() {
      homeController().then((res) => {
        this.popList = res.data;
        // 排序
        this.popList.sort((a, b) => {
          return a.position - b.position;
        });
        // console.log(res, 11111111111);
      });
    },
    getMenuData() {
      getMenuList().then(async (res) => {
        var routerList = res.data;
        var routerStr = JSON.stringify(routerList);
        routerStr = routerStr.replace(/title/g, "tittle");
        routerList = JSON.parse(routerStr);
        await this.routeLocal(routerList);
        localStorage.setItem("permissionPath", JSON.stringify(this.pathList));
        if (
          this.permissionPath.join() !==
          JSON.parse(JSON.stringify(this.pathList)).join()
        ) {
        }
        this.$store.state.route = routerList;
      });
    },

    getSellerPlatform() {
      getSellerPlatform().then((res) => {
        console.log("平台板用户信息", res);
        sessionStorage.setItem("sellerPlatform", JSON.stringify(res.data));
        const { data } = res;
        this.sellerPlatform = data;
        this.platformFlag = data.platformFlag;
      });
    },
    getSeller() {
      this.loading = true;
      sessionStorage.removeItem("loginUserInfo");
      getSeller().then((res) => {
        this.loading = false;
        if (res.code == 1) {
          this.loginUserInfo = res.data;
          sessionStorage.setItem("loginUserInfo", JSON.stringify(res.data));
        } else {
          this.$message.warning(res.message);
        }
      });
    },

    // 将路由存在本地
    routeLocal(list) {
      list.map((item) => {
        if (!item.children) {
          if (item.path == "/home") {
            this.pathList.push("home");
          } else if (item.path == "/industryPreview") {
            this.pathList.push("industryPreview");
          } else {
            if (item.path == "goods_repurchase") {
              // 由于商品复购和商品复购周期分析path相同，所以将title存入用于后续判断
              this.pathList.push(item.tittle);
            }
            this.pathList.push(item.path);
          }
        } else {
          this.routeLocal(item.children);
        }
      });
    },

   async getBindList() {
      this.loading = true;
      sessionStorage.removeItem("loginUserInfo");
      getSellerInfo().then((resp) => {
        this.loading = false;
        if (resp.code == 1) {
          this.loginUserInfo = resp.data;
          sessionStorage.setItem("loginUserInfo", JSON.stringify(resp.data));
          this.getShopAllList()
        } else {
          this.$message.warning(resp.message);
        }
        console.log("平台板用户信息", resp);
        sessionStorage.setItem("sellerPlatform", JSON.stringify(resp.data));
        const { data } = resp;
        this.sellerPlatform = data;
        this.platformFlag = data.platformFlag;
        // console.log(resp.data);
        this.editUserInfo(resp && resp.data);
        this.venId = resp.data.venderId;
        const name = resp.data.contactName;
        getShopInfo().then((res) => {
          this.fuxinSms = res.data.digitalBalance;
          sessionStorage.setItem("fuxin", res.data.digitalBalance);
          if (res.code == "1") {
            this.saveShopInfo(res && res.data);
            var switchList = res.data.bindshop;
            if (switchList && switchList.length > 0) {
              var sellerNick = resp.data.sellerNick;
              // console.log("sellerNick:", sellerNick);
              switchList.forEach((item) => {
                if (item.claimer == sellerNick) {
                  item.shopName = item.hostshop;
                } else {
                  item.shopName = item.claimer;
                }
              });
              this.switchList = switchList;
              this.getSwitchList(this.switchList);
            }
          }
        });
      });
    },
    async topTab(ind, item) {
      sessionStorage.removeItem("markNum");
      sessionStorage.removeItem("markId");
      sessionStorage.removeItem("statusNames");
      // 互动营销
      if (item.path == "/interactive") {
        const res = await getSeller();
        if (res.data.isOrderHd) {
          window.open(
            "https://open-oauth.jd.com/oauth2/to_login?app_key=22AF00009B3D46B8DECBC457090B3560&response_type=code&redirect_uri=http://jdhd.tj9.co/jd-hd-web/yhd/auth/callback&state=jdShop&scope=snsapi_base",
            "_blank"
          );
          return;
        }
      }
      this.topActive = ind;
      this.activeNavStyle = this.getNavStyle(ind);
      var path = item.path;

      if (item.children && item.children[0].path) {
        path = item.path + "/" + item.children[0].path;
      }

      if (
        item.children &&
        item.children[0].path &&
        item.children[0].children &&
        item.children[0].children[0].path
      ) {
        path =
          item.path +
          "/" +
          item.children[0].path +
          "/" +
          item.children[0].children[0].path;
      }
      // 新页面打开 bi
      if (item.path == "bi") {
        window.open("/platform/" + path, "_blank");
        return;
      }
      // console.log("path==", path);
      this.$router.push({ path: path });
      this.bus.$emit("topActive", { index: ind, item: item });
      if (item.path == "/integralCenter") {
        this.loginEvent();
      }
    },
    //登录
    loginEvent() {
      let venderId = { venderId: this.venId };
      console.log(venderId);
    },
    //退出登录
    log_out() {
      logout().then((res) => {
        if (res.code == 1 || res.code == 200) {
          this.$message.success("退出成功");
          setTimeout(() => {
            location.href = res.message;
          }, 2000);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getNavStyle(index) {
      if (sessionStorage.getItem("pathsOne") == "/bi") return;
      let childNodes = this.$refs.mainHeader.childNodes;
      let width = Number(childNodes[index] && childNodes[index].clientWidth);
      let left = 0;
      if (index > 0) {
        for (let i = 0; i < index; i++) {
          if (this.screenWidth < 1370) {
            left += childNodes[i].clientWidth + 5;
          } else if (this.screenWidth > 1369 && this.screenWidth < 1572) {
            left += childNodes[i].clientWidth + 5;
          } else if (this.screenWidth > 1572 && this.screenWidth < 1800) {
            left += childNodes[i].clientWidth + 29;
          } else {
            left += childNodes[i].clientWidth + 10;
          }
        }
      }
      return { width, left };
    },
    //复制
    copyBtn(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      let isTrue = document.execCommand("Copy"); // 执行浏览器复制命令
      if (isTrue) {
        this.$message.success("复制成功！");
      } else {
        this.$message.error("复制失败！");
      }
      oInput.remove();
    },
    itemClick(val) {
      this.$emit("itemClick", val);
    },
    // 续费
    AppAuth() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1415006?rdct=true",
        "_blank"
      );
    },
    // 获取京获客旗舰版用户用户信息
    getJhkSellerInfo() {
      getJhkSellerInfo().then((res) => {
        if (res.code == 1) {
          this.saveJhkPlatformSeller(res.data ? res.data.isPlatformSeller : '')
        } else {
          this.$message.warning(res.message);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.header-class {
  min-width: 1349px;
}

.displayStart {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.rightContent {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  height: 60px;
  // line-height: 60px;
  text-align: center;
  padding-right: 30px;
  display: flex;
  align-items: center;
  
  .white-bar {
    width: 90px;
    height: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-right: 30px;
  }

  .daoQi {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }

  .ai_button {
    width: 81px;
    height: 100%;
    border-radius: 2px;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
    line-height: 60px;
    display: flex !important;
    align-items: center;
    cursor: pointer;
  }

  .helpBlock {
    margin: 0 30px;
    height: 60px;

    .title {
      margin-right: 4px;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 16px;
    }

    .tips {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #ffffff;
    }
  }

  .shopBlock {
    height: 60px;

    .title {
      margin-right: 4px;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 16px;
    }

    .tips {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #ffffff;
      margin-right: 30px;
    }
  }

  .head-name {
    .head-name-tit {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 106px;
    }
  }
}

.customerService {
  font-size: 12px;
  padding: 10px;

  .title {
    font-weight: 400;
    font-size: 13px;
    color: #666666;
  }

  .toService {
    margin-bottom: 12px;

    .title {
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 15px;
    }

    .phone {
      display: flex;
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      line-height: 16px;

      img {
        width: 16px;
        height: 16px;
        vertical-align: middle;
        margin-left: 6px;
      }
    }
  }

  .wechatService {
    margin-top: 17px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .QRcode {
      width: 80px;
      height: 80px;

      .title {
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        line-height: 14px;
        text-align: left;
      }
    }
  }

  .copyBtnHover {
    display: none;
  }

  .copyBtn {
    display: block;
  }
}

.phoneBtn:hover {
  .copyBtn {
    display: none;
  }

  .copyBtnHover {
    display: block;
  }
}

.help {
  margin-bottom: 31px;
  display: flex;
  // padding: 0 10px;
  justify-content: flex-start;

  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 14px;
  color: #666666;
  cursor: pointer;

  div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    width: 100px;
  }

  .helpNoHover {
    display: flex;
  }

  .helpHover {
    display: none;
  }
}

.help:hover {
  .helpHover {
    display: flex;
  }

  .helpNoHover {
    display: none;
  }
}

.help div:hover {
  color: #2e74fe;
}

.details {
  width: 100%;
  padding: 12px;

  .shopTitle {
    margin-bottom: 16px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .title {
      font-weight: 600;
      font-size: 12px;
      color: #333333;
      line-height: 16px;
      margin-left: 4px;
    }
  }

  .details_top {
    display: flex;
    flex: 1;
    text-align: left;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 9px;

    .txt {
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 16px;
      margin-top: 4px;
    }

    .autograph {
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      line-height: 16px;
    }
  }

  .details_bottom {
    padding-top: 4px;
    border-top: 1px dashed rgba(0, 0, 0, 0.15);

    .bottom_content {
      padding-top: 12px;

      .text {
        font-size: 12px;
        color: #666666;
      }

      >div:first-child {
        display: flex;
        align-items: center;
        justify-content: space-between;

        >div:first-child {
          >span:last-child {
            font-weight: bold;
          }
        }
      }
    }

    .left_content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .txt {
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      line-height: 16px;
    }

    .time {
      font-size: 12px;
      color: #333333;
      line-height: 16px;
    }

    .payBtn {
      font-weight: 400;
      font-size: 12px;
      color: #2e74fe;
      line-height: 18px;
    }
  }

  .recharge,
  .renew {
    width: 48px;
    height: 24px;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #dcdfe6;
    font-weight: 400;
    font-size: 12px;
    color: #1f1f1f;
    line-height: 15px;

    &:hover {
      color: #666666;
      background: #f2f3f5;
    }

    &:active {
      color: #666666;
      background: #f2f3f5;
    }
  }
}

.switch-content {
  font-weight: 400;
  font-size: 12px;
  color: #333333;
  white-space: nowrap;
  overflow: visible;
  text-overflow: ellipsis;
  cursor: pointer;
  padding: 0 10px;
  line-height: 36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.switch-content.active {
  color: #2e74fe;
}

.switch-content:hover {
  // color: #FE4D45;
  height: 36px;
  background: #f5f5f7;

  .shop-name-setDefault {
    display: inline-block;
  }

  .shop-name-empty {
    display: none;
  }
}

.shop-name {
  display: flex;
  align-items: center;

  &-default {
    border-radius: 4px;
    color: #fff;
    background-color: #2768ff;
    font-size: 10px;
    line-height: normal;
    padding: 2px 4px;
    margin-left: 8px;
  }

  &-setDefault {
    display: none;
  }

  &-empty {
    width: 56px;
  }
}

.callkf1 {
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 16px;
  text-align: center;
  /* margin: 0 auto; */
  cursor: pointer;
}

.container {
  overflow: hidden;
  height: 50px;
  width: 100%;
  margin-bottom: 16px;
  transition: all 0.5s;
  // position: fixed;
  // top: 0;
  // left: 0;
  z-index: 10;
  // max-width: 1920px;
  // margin: 0px auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #3159ff;
  background-image: url("~@/assets/homePage/head.png");
  background-size: 100% 100%;
  /* 背景图片覆盖整个元素 */
  background-repeat: no-repeat;

  /* 背景图片不重复 */
  .logo {
    box-sizing: border-box;
    width: 200px;
    opacity: 1;
    vertical-align: top;
    display: inline-block;
    height: 60px;
    text-align: center;
    line-height: 65px;

    @media screen and (min-width: 1500px) and (max-width: 1700px) {
      line-height: 68px;
    }

    @media screen and (min-width: 1400px) and (max-width: 1499px) {
      line-height: 69px;
    }

    @media screen and (max-width: 1399px) {
      line-height: 70px;
    }

    padding: 5px 0;
    text-align: center;

    img {
      display: inline-block;
      margin-top: -22px;

      // width: 140px;
      @media screen and (max-width: 1366px) {
        margin-top: -24px;
      }

      // height: 40px;
      vertical-align: middle;
    }

    img:after {
      content: "";
      display: inline-block;
      vertical-align: middle;
    }
  }

  .module {
    // display: inline-block;
    // margin-left: 20px;
    min-width: 444px;

    @media screen and (min-width: 1500px) and (max-width: 1800px) {
      margin-left: 0;
      overflow: auto;
      // width: 66%;
    }

    @media screen and (min-width: 1400px) and (max-width: 1499px) {
      margin-left: 0;
      overflow: auto;
      // width: 62%;
    }

    @media screen and (max-width: 1399px) {
      margin-left: 0;
      overflow: auto;
      // width: 58%;
    }

    .nav {
      display: inline-flex;
      position: relative;
      height: 60px;
      line-height: 72px;
      overflow: hidden;
      margin-left: 38px;

      .nav-item {
        position: relative;
        margin-right: 20px;
        bottom: 5px;
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
        position: relative;
        // &:hover::before {
        //   bottom: -5px;
        //   opacity: 1;
        //   // @media screen and (max-width: 1300px) {
        //   //   bottom: -2px;
        //   // }
        // }
        // &::before {
        //   content: "";
        //   position: absolute;
        //   bottom: -11px;
        //   left: 0;
        //   width: 100%;
        //   height: 4px;
        //   background-color: #555a7a;
        //   border-radius: 8px 8px 0 0;
        //   // opacity: 0;
        //   // transition: 0.3s;
        // }
      }

      .nav-pcImgUrl {
        padding: 0;

        &::before {
          background-color: transparent !important;
        }
      }

      .nav-underline {
        position: absolute;
        bottom: 0;
        display: block;
        height: 4px;
        top: 56px;
        border-radius: 8px 8px 0 0;
        background-color: #fe4d45;
        transition: all 0.4s ease-in-out;
      }

      .navActive {
        font-weight: bold;
        font-size: 14px;
        color: white;
      }

      // .nav-item.navActive {
      //   // &::before {
      //   //   bottom: 0;
      //   //   opacity: 1;
      //   //   background-color: #FE4D45;
      //   // }
      // }
    }
  }
}

@media screen and (min-width: 1572px) and (max-width: 1800px) {
  .container {
    .module {
      .nav {
        margin-left: 18px;

        .nav-item {
          // margin-right: 29px;
        }

        .navLeft {
          margin-left: -29px;
        }
      }
    }
  }
}

@media screen and (min-width: 1480px) and (max-width: 1572px) {
  .container {
    .module {
      .nav {
        margin-left: 9px;

        .nav-item {
          margin-right: 5px;
        }

        .nav-pcImgUrl {
          margin-right: 15px;
        }

        .navLeft {
          margin-left: -5px;
        }
      }
    }
  }
}

@media screen and (min-width: 1400px) and (max-width: 1480px) {
  .container {
    .module {
      .nav {
        margin-left: 4px;

        .nav-item {
          margin-right: 0;
          width: 80px;
          font-size: 16px;
          padding: 0 5px;

          &:hover {
            font-weight: bold;
            font-size: 16px;
            color: #1f1f1f;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1400px) {
  .container {
    .module {
      .nav {
        margin-left: 4px;

        .nav-item {
          margin-right: 0;
          width: 72px;
          font-size: 14px;
          padding: 0 5px;

          &:hover {
            font-weight: bold;
            font-size: 14px;
            // color: #1F1F1F;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.dialongTransition12 {
  .el-dialog {
    background: transparent;
    box-shadow: none !important;

    // box-shadow: 0 0px 0px rgba(0, 0, 0, 0.3);
    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      background: transparent;
    }
  }
}

.platformFlag.el-popover {
  padding: 0px !important;
}

.outWidth {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  // width: 140px;
  margin: 0 8px;

  .storeName {
    font-size: 12px;
    color: #ffffff;
  }
}

.shopSwitch {
  border-bottom: 1px solid #eeeeee;
  max-height: 185px;
  overflow-y: auto;
  overflow-x: hidden;
  // /* 隐藏滚动条（仅适用于 Internet Explorer 和 Edge） */
  // -ms-overflow-style: none;

  // /* 隐藏滚动条（适用于 Firefox） */
  // scrollbar-width: none;
}

.welcome {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  text-align: left;
  margin: 0 24px 0 14px;
}

.shopTitle {
  text-align: left;
}

@media screen and (max-width: 1360px) {
  .welcome {
    display: none;
  }

  .rightContent {
    .shopBlock {
      margin-right: 0;
    }
  }

  .outWidth {
    width: 137px;
  }

  .shopTitle {
    margin: 0 0 0 8px;
  }
}
</style>

<style lang="scss" scoped>
.validityText {
  color: #2768ff;
  text-decoration: underline;
  cursor: pointer;
}

.fs12 {
  font-size: 12px;
}

.colorfff {
  color: #fff !important;
}

.mt4 {
  margin-top: 4px;
}

.timeStyle {
  font-size: 12px;
  color: white;
  display: flex;
  align-items: center;
}

.renewStyle {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #804500;
  width: 48px;
  height: 22px;
  background: linear-gradient(180deg, #FFF0C1 0%, #FFB14E 100%);
  border-radius: 13px 13px 13px 13px;
  margin-left: 8px;
  justify-content: center;
  cursor: pointer;
}
</style>
